import React, { forwardRef } from 'react';

import NextExportedImage, { ExportedImageProps } from 'next-image-export-optimizer';

import { BASE_PATH } from '@/shared-functions/basePath';

/**
 * next-image-export-optimizer takes basePath as a prop and defaults it to an
 * empty string - it never reads the value out of next.config.mjs. Without it
 * every generated image URL points at the domain root instead of the subpath
 * the site is served from.
 *
 * Import this instead of the package directly so the prefix is applied in one
 * place rather than at each of the call sites. The props and the forwarded ref
 * are the package's own, so call sites keep their type checking.
 */
export const ExportedImage = forwardRef<HTMLImageElement | null, ExportedImageProps>(
  ({ basePath = BASE_PATH, ...props }, ref) => (
    <NextExportedImage ref={ref} basePath={basePath} {...props} />
  ),
);

ExportedImage.displayName = 'ExportedImage';

export default ExportedImage;
